import Immutable from 'immutable';
import type { Map } from 'immutable';
import type { AnyAction, Reducer } from 'redux';
import { combineReducers } from 'redux-immutable';
import { GET_SALES_PROVISION, GET_SINGLE_PAYMENT_PROVISION } from './actions';

const salesDashboardReducer: Reducer<Map<string, unknown>, AnyAction> =
  Reflect.apply(combineReducers, undefined, [
    {
      provision: salesDashboardProvisionReducer,
      singleTime: salesDashboardSinglePaymentReducer,
    },
  ]);

export default salesDashboardReducer;

function salesDashboardProvisionReducer(
  state: Map<string, unknown> = Immutable.fromJS({
    loading: false,
    data: undefined,
    errorMessage: undefined,
  }),
  action: AnyAction,
): Map<string, unknown> {
  switch (action.type) {
    case GET_SALES_PROVISION: {
      return state.merge(
        Immutable.fromJS({
          data: action.data,
          loading: false,
          errorMessage: undefined,
        }),
      );
    }
    case `${GET_SALES_PROVISION}_LOADING`: {
      return state.merge({
        data: undefined,
        loading: true,
        errorMessage: undefined,
      });
    }
    case `${GET_SALES_PROVISION}_ERROR`: {
      return state.merge({
        data: undefined,
        loading: false,
        errorMessage: JSON.stringify(action),
      });
    }
    default: {
      return state;
    }
  }
}

function salesDashboardSinglePaymentReducer(
  state: Map<string, unknown> = Immutable.fromJS({
    loading: false,
    data: undefined,
    errorMessage: undefined,
  }),
  action: AnyAction,
): Map<string, unknown> {
  switch (action.type) {
    case GET_SINGLE_PAYMENT_PROVISION: {
      return state.merge(
        Immutable.fromJS({
          data: action.data,
          loading: false,
          errorMessage: undefined,
        }),
      );
    }
    case `${GET_SINGLE_PAYMENT_PROVISION}_LOADING`: {
      return state.merge({
        data: undefined,
        loading: true,
        errorMessage: undefined,
      });
    }
    case `${GET_SINGLE_PAYMENT_PROVISION}_ERROR`: {
      return state.merge({
        data: undefined,
        loading: false,
        errorMessage: JSON.stringify(action),
      });
    }
    default: {
      return state;
    }
  }
}
